"use client";

import { createContext, useContext } from "react";
import type {
  CandidateCertification,
  CandidateEducation,
  CandidateExperience,
  CandidateLanguage,
  CandidateProfile,
} from "@/lib/api/types";

export interface ProfileSections {
  education: CandidateEducation[];
  certifications: CandidateCertification[];
  languages: CandidateLanguage[];
  experiences: CandidateExperience[];
}

export interface ProfileDerived {
  firstName: string;
}

export interface ProfileContextValue {
  profile: CandidateProfile | null;
  profileId: string | null;
  sections: ProfileSections;
  derived: ProfileDerived;
}

export const ProfileContext = createContext<ProfileContextValue | null>(null);

export function useProfile(): ProfileContextValue {
  const ctx = useContext(ProfileContext);
  if (ctx === null) {
    throw new Error("useProfile must be used within a ProfileContext provider");
  }
  return ctx;
}

/**
 * Sub-hook for descendants that only need the typed section arrays.
 * Returns the same reference as useProfile().sections so descendants that
 * read multiple sections do not over-render when only `derived` changes.
 */
export function useProfileSections(): ProfileSections {
  return useProfile().sections;
}
